import { useGetPopper } from './useGetPopper';
export function useGetTrigger(triggerId) {
  if (!triggerId) {
    throw new Error('useGetTrigger must have triggerId param');
  }

  var popper = useGetPopper();
  return popper.getTrigger(triggerId);
}